import { FormEvent, memo, useMemo, useState } from "react";
import ConversationFeedback from './styles';
import { useAppDispatch, useAppSelector } from '../../../../../common/store';
import { feedbackFormSelector } from "../../../../../common/store/chat/selectors";
import { setGetFeedback } from "../../../../../common/store/chat/chat-slice";
import { sendMessageLogSubmission } from "../../../../../common/store/chat/thunks/send-message-log";
import VurbalizeEvents from "../../../../../common/types/dto/chat/vurbalize-events";
import getMessageByVurablizeEvent from "../../../../utils/get-message-by-vurablize-event";
import { FeedbackCloseIcon } from "../../../../components/icons/feedback-close-icon";
import { sendFeedbackForm } from "../../../../../common/store/chat/thunks/send-feedback-form";

export const FeedbackForm = () => {
  const dispatch = useAppDispatch();
  const getFeedback = useAppSelector(feedbackFormSelector);
  const [feedbackText, setFeedbackText] = useState('');
  const [radioValue, setRadioValue] = useState('');
  const [error, setError] = useState(false);
  
  const isDisabled = useMemo(() => radioValue === '' && feedbackText === '', [radioValue, feedbackText])

  if (!getFeedback) {
    return null;
  }

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    setError(!radioValue);
    if (!radioValue) return;

    const formData = {
      feedbacktext: feedbackText,
      feedback: radioValue,
    };

    dispatch(sendFeedbackForm(formData));
  }

  const onClose = () => {
    dispatch(setGetFeedback(false));
    dispatch(sendMessageLogSubmission({data: {
      message: getMessageByVurablizeEvent(VurbalizeEvents.USER_FEEDBACK_CLOSE),
      event_name: VurbalizeEvents.USER_FEEDBACK_CLOSE,
    }}))
  }

  return (
    <ConversationFeedback className="conversation_feedback">
      <div className="voa_close_59o7kg" onClick={onClose}>
        <FeedbackCloseIcon />
      </div>
      <form onSubmit={onSubmit}>
      <p>Please help us to improve.</p>
      <div className="radioOptions">
        {Array.from({ length: 10 }, (_, i) => (
          <label key={i}>
            {i + 1}
            <input
              type="radio"
              name="feedback"
              value={i + 1}
              onChange={(e) => setRadioValue(e.target.value)}
            />
          </label>
        ))}
      </div>
      <div className="feedbackbox">
        <textarea
          name="feedbacktext" 
          value={feedbackText} 
          onChange={(e) => setFeedbackText(e.target.value)} 
          placeholder="Please enter your feedback" 
        />
      </div>
      <button type="submit" value="submit" name="submit" disabled={isDisabled}>Submit</button>
      {error &&
        <div className="error">Please select rating before submitting your feedback</div>
      }
      </form>
    </ConversationFeedback>
  )
};
